export default "__VITE_ASSET__BzLZ8lmW__"